module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-72x72.8f186463012fa7b49ad4a0de149bf6c9.png";